import { Grid, Typography } from "@mui/material";
import PrimaryButton from "components/PrimaryButton";
import { Maybe } from "graphql/jsutils/Maybe";
import { TechnicianType } from "operations/schema/schema";
import { FC, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useAppSelector } from "store";
import { isFlagEnabled } from "store/slices/user.store";
import { CustomerEmailInput } from "./CustomerEmailInput";
import { TechnicianSelect } from "./TechnicianSelect";

export interface RemoteAccessSendEmailProps {
  initialEmail?: Maybe<string>;
  onCancel: () => void;
  onSendCustomer: (email: string) => void;
  onSendTechnician: (technician: TechnicianType) => void;
}

export const RemoteAccessSendEmail: FC<RemoteAccessSendEmailProps> = (props) => {
  const { initialEmail, onSendCustomer, onSendTechnician, onCancel } = props;
  const [accessType, setAccessType] = useState<"technician" | "customer" | null>("customer");
  const askTechnicianEnabled = useAppSelector((s) => isFlagEnabled(s, "RemoteAccessTechnician"));

  return (
    <>
      {accessType == null && (
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item>
            <Typography>
              <FormattedMessage id="remoteAccess.howToUse" />
            </Typography>
          </Grid>
          {askTechnicianEnabled && (
            <Grid item>
              <PrimaryButton onClick={() => setAccessType("technician")} size="large">
                <FormattedMessage id="remoteAccess.askTechnician" />
              </PrimaryButton>
            </Grid>
          )}
          <Grid item>
            <PrimaryButton onClick={() => setAccessType("customer")} size="large">
              <FormattedMessage id="remoteAccess.accessCustomer" />
            </PrimaryButton>
          </Grid>
        </Grid>
      )}
      {accessType === "technician" && (
        <TechnicianSelect
          onSendTechnicianEmail={onSendTechnician}
          onCancel={() => {
            setAccessType("customer");
          }}
        />
      )}
      {accessType === "customer" && (
        <CustomerEmailInput
          initialEmail={initialEmail}
          onCancel={onCancel}
          onSendEmail={onSendCustomer}
        />
      )}
    </>
  );
};
